import { useEffect, useState } from 'react'
import axios from 'axios'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import moment from 'moment'

export const MonitoringComponent = () => {

    const [monitoringResults, setMonitoringResults] = useState([]);
    const [refreshCount, setRefreshCount] = useState(0);

    useEffect(() => {
        axios.get("/api/monitoring")
            .then(response => {
                if (response.data) {
                    setMonitoringResults(response.data);
                }
            })
    }, [refreshCount]);

    const [filters] = useState({

        category: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

        target: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

        author: { value: null, matchMode: FilterMatchMode.CONTAINS },

        idStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    });

    const displayDate = date => {
        if (date) {
            return moment(date).format('LLL:ss');
        }
        else {
            return '';
        }
    }

    const displayTimeTakenTemplate = row => {
        if (row.timeTaken) {
            let time = moment.duration(row.timeTaken)

            let timeString = '';
            if (time.hours() > 0) {
                timeString += time.hours() + ' h '
            }
            if (timeString || time.minutes() > 0) {
                timeString += time.minutes() + ' min '
            }

            timeString += `${time.seconds()} s ${time.milliseconds()} ms`

            return timeString;
        }
        else {
            return '';
        }
    }

    const displayDateRegisteredTemplate = row => displayDate(row.dateRegistered);
    const displayDateBeginTemplate = row => displayDate(row.dateBegin);
    const displayDateEndTemplate = row => displayDate(row.dateEnd);

    const displayStatus = row => {

        switch (row.idStatus) {
            case 1:
                return <i className="pi pi-ellipsis-h text-primary"  ></i>
            case 2:
                return <i className="pi pi-carret-right text-primary"  ></i>
            case 3:
                return <i className="pi pi-check text-success"  ></i>
            case 4:
                return <i className="pi pi-minus-circle text-danger" ></i>
            default:
                return "";
        }
    }

    const statusFilterTemplate = (options) => {
        return <select className="form-select" value={options.value} onChange={(e) => {
            if (e.target.value) {
                options.filterApplyCallback(e.target.value)
            }
            else {
                options.filterApplyCallback(null)
            }
        }
        } >
            <option value="" hidden>selectionnez</option>
            <option value="">Tous les status</option>
            <option value="1">Pas commencé</option>
            <option value="2">Commencé</option>
            <option value="3">Succès</option>
            <option value="4">Echec</option>
        </select>

    };

    return <div >
        <div className="alert alert-info">
            Cet écran vous permet de monitorer les jobs de pocahontas<br />
            <button className="btn btn-outline-primary" onClick={ () => setRefreshCount(refreshCount + 1) } >Rafraîchir</button>
        </div>

        <DataTable value={monitoringResults} tableStyle={{ width: '100%' }}
            filters={filters} filterDisplay="row">
            <Column field="category" header="Categorie" filter sortable />
            <Column field="target" header="Cible" filter sortable />
            <Column field="author" header="Auteur" filter sortable  />
            <Column field="dateRegistered" header="Date d'enregistrement" body={ displayDateRegisteredTemplate } sortable />
            <Column field="dateBegin" header="Date de début" body={ displayDateBeginTemplate} sortable />
            <Column field="dateEnd" header="Date de fin" body={ displayDateEndTemplate } sortable />
            <Column field="timeTaken" header="Temps mis" sortable body={displayTimeTakenTemplate} />
            <Column field="idStatus" header="Status" body={displayStatus} filter filterElement={statusFilterTemplate} showFilterMenu={ false } />
        </DataTable>
    </div>
}





